import React, { useState, useMemo } from 'react'
import { Spinner, Text, Pagination } from '@shopify/polaris'
import { Doughnut } from 'react-chartjs-2'
import { beforeDraw } from '../utils/chartUtils'
import _ from 'lodash'

const ThresholdUSSection = ({ thresholdUS, fetchingThresholdUS, t, navigate }) => {
	const [activeStateInd, setActiveStateInd] = useState(0)
	const items = thresholdUS ? thresholdUS.items : []

	const handlePrevious = () => {
		setActiveStateInd((prev) =>
			prev > 0 ? prev - 1 : items.length - 1
		)
	}

	const handleNext = () => {
		setActiveStateInd((prev) =>
			prev < items.length - 1 ? prev + 1 : 0
		)
	}

	const currentItem = useMemo(() => items[activeStateInd], [items, activeStateInd])

	const chartData = useMemo(() => {
		if (!currentItem) return null

		const total = 100
		const percentFact = currentItem.percent
		const thresholdFactSum = currentItem.fact_sum
		const thresholdSum = Math.round(currentItem.threshold_sum)

		return {
			datasets: [
				{
					data: [
						percentFact,
						total - (percentFact || 0),
					],
					radius: "100%",
					cutout: 70,
					backgroundColor: ["#59C7C5", "#DAF1F2"],
					borderColor: ["#59C7C5", "#DAF1F2"],
					hoverBackgroundColor: ["#59C7C5", "#DAF1F2"],
				},
			],
		}
	}, [currentItem])

	const chartOptions = useMemo(() => ({
		plugins: {
			tooltip: {
				callbacks: {
					label: function (context) {
						return `${context.formattedValue}%`
					},
				},
			},
		},
	}), [])

	if (fetchingThresholdUS) {
		return <Spinner />
	}

	if (_.isEmpty(items)) {
		return (
			<div style={{ background: '#fff', borderRadius: 8, padding: 20, border: '1px solid rgba(227, 227, 227, 1)' }}>
				<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
					<h2 style={{ fontWeight: 'bold', fontSize: 18 }}>{t("home.thresholdUSA")}</h2>
					<button
						style={{
							background: '#fff',
							borderColor: 'transparent',
							color: 'rgba(44, 110, 203, 1)',
							cursor: 'pointer',
							fontSize: 14,
							fontWeight: 400,
						}}
						onClick={() => navigate("/home/threshold")}
					>
						{t("home.viewAll")}
					</button>
				</div>
				<Text>{t("home.noData")}</Text>
			</div>
		)
	}

	if (!currentItem) return null

	const percentFact = currentItem.percent
	const thresholdFactSum = currentItem.fact_sum
	const thresholdSum = Math.round(currentItem.threshold_sum)

	return (
		<div style={{ background: '#fff', borderRadius: 8, padding: 20, border: '1px solid rgba(227, 227, 227, 1)' }}>
			<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
				<h2 style={{ fontWeight: 'bold', fontSize: 18 }}>{t("home.thresholdUSA")}</h2>
				<button
					style={{
						background: '#fff',
						borderColor: 'transparent',
						color: 'rgba(44, 110, 203, 1)',
						cursor: 'pointer',
						fontSize: 14,
						fontWeight: 400,
					}}
					onClick={() => navigate("/home/threshold")}
				>
					{t("home.viewAll")}
				</button>
			</div>
			<div>
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<Pagination
						label={
							<Text as="h6" variant="headingMd" fontWeight="bold">
								{currentItem.state}
							</Text>
						}
						hasPrevious
						onPrevious={handlePrevious}
						hasNext
						onNext={handleNext}
					/>
				</div>
				<br />
				<div
					key={currentItem.state_code}
					className='dash-chart-container'
				>
					<Doughnut
						options={chartOptions}
						data={chartData}
						plugins={[
							{
								beforeDraw: (chart) =>
									beforeDraw(
										chart,
										percentFact,
										thresholdFactSum,
										thresholdSum,
										"$"
									),
							},
						]}
					/>
				</div>
			</div>
		</div>
	)
}

export default ThresholdUSSection

